import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "bootstrap/js/src/dropdown";
import {
  MARKET_PLACE,
  HOME,
  GBET_ROUTE,
  // CROWN_REDEMPTION,
  LEADERSHIP,
  PRESALE,
  WALLET,
  ILLUSTRATION_GALLERY,
  ACTIVITY_LOG,
  MIGRATION,
} from "src/constants/routes";

import {
  useCurrentAccount,
  ConnectModal,
  useDisconnectWallet,
} from "@mysten/dapp-kit";
import * as icon from "services/icon";
import { connectResponse } from "utils/connectResponse";
import {
  fetchWalletSuccess,
  removeWalletAddress,
  detectMarketPlaceApproved,
} from "../../redux/actions/wallet";
import ConnectWalletModal from "components/Modals/ConnectWalletModal";
import DisconnectModal from "components/Modals/DisconnectModal";
import ConnectionOptionModal from "components/Modals/ConnectionOptionModal";
import { CONNECT_WALLET, ICONEX, LEDGER, NEW_GB } from "src/constants/images";
import { GoLinkExternal } from "react-icons/go";
import { RootState, WindowDimensions, Theme } from "../../types";
import logger from "../../utils/logger";

const Header: React.FC = () => {
  !localStorage.getItem("theme") && localStorage.setItem("theme", "dark");
  const walletAccount = useCurrentAccount();
  const { mutate: disconnectSuiWallet } = useDisconnectWallet();
  const suiAddress = walletAccount?.address || null;
  const [theme, setTheme] = useState<Theme | null>(localStorage.getItem("theme") as Theme);
  const [toggleStatus, setToggleStatus] = useState<boolean>(
    theme === "dark" ? true : false
  );

  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute("data-theme", theme);
    }
  }, [theme]);

  const toggleTheme = (): void => {
    let gtheme: Theme = theme || "dark";
    if (gtheme === "light") {
      gtheme = "dark";
    } else {
      gtheme = "light";
    }
    setTheme(gtheme);
    document.documentElement.setAttribute("data-theme", gtheme);
    localStorage.setItem("theme", gtheme);
    setToggleStatus(gtheme === "light" ? false : true);
  };

  const { walletAddress: address, walletType } = useSelector(
    (state: RootState) => state.wallet
  );

  const hasWindow = typeof window !== "undefined";

  function getWindowDimensions(): WindowDimensions {
    const width = hasWindow ? window.innerWidth : null;
    return {
      width,
    };
  }
  const [openSuiModal, setOpenSuiModal] = useState(false);
  const [connectLoading, setConnectLoading] = useState<boolean>(false);
  const [connectSuccess, setConnectSuccess] = useState<{ status: string }>({ status: "loading" });
  const [disconnect, setDisConnect] = useState<boolean>(false);
  const [walletConnection, setWalletConnection] = useState<boolean>(false);
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(
    getWindowDimensions()
  );

  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow]);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!address) {
  //     window.addEventListener("ICONEX_RELAY_RESPONSE", eventHandler, false);
  //   } else {
  //     window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
  //   }

  //   return () => {
  //     window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
  //   };
  // }, [address]);

  useEffect(() => {
      window.addEventListener("ICONEX_RELAY_RESPONSE", eventHandler, false);
    return () => {
      window.removeEventListener("ICONEX_RELAY_RESPONSE", eventHandler);
    };
  }, []);

  const eventHandler = async (event: any): Promise<void> => {
    const response = await connectResponse(event);
    const success = { status: "success" };
    const cancel = { status: "cancel" };
    const error = { status: "error" };

    switch (response.type) {
      case "address":
        dispatch(fetchWalletSuccess(response.data));
        setConnectSuccess(success);
        break;

      case "json-RPC":
        setTimeout(() => {
          icon.getTransactionResult(response.data.result);
        }, 4000);
        break;

      case "cancel":
        setConnectSuccess(cancel);
        break;

      default:
        setConnectSuccess(error);
    }
  };

  const handleLogin = async (): Promise<void> => {
    setConnectLoading(true);
    setConnectSuccess({ status: "loading" });
    icon.handleLogin();
  };

  const handleConnect = (): void => {
    if (address) {
      setDisConnect(true);
    } else {
      setWalletConnection(true);
    }
  };

  const handleClose = (): void => {
    setConnectLoading(false);
    setConnectSuccess({ status: "loading" });
  };

  const checkWalletAddress = (): string => {
    if (address) {
      return WALLET.addSlug(WALLET.INDEX, address);
    }
    return WALLET.addSlug(WALLET.INDEX, "connect");
  };

  const handleDisConnected = (): void => {
    dispatch(removeWalletAddress());
    dispatch(detectMarketPlaceApproved(false));
    const walletDisconnectPath = WALLET.addSlug(WALLET.INDEX, address || "");

    if (pathname === walletDisconnectPath) {
      navigate(WALLET.addSlug(WALLET.INDEX, "connect"));
    }
  };

  // Function to collapse navbar on mobile when links are clicked
  const collapseNavbar = (): void => {
    if (windowDimensions.width && windowDimensions.width < 768) { // md breakpoint
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarCollapse = document.querySelector('.navbar-collapse');
      
      if (navbarToggler && navbarCollapse && navbarCollapse.classList.contains('show')) {
        (navbarToggler as HTMLElement).click();
      }
    }
  };

  return (
    <header>
      <div className="header">
        <div className="container">
          <div className=" navigation-bar navbar navbar-expand-md navbar-light  container pt-0 pt-lg-1">
            <Link to={HOME.INDEX} className="logo-container  mt-2" onClick={collapseNavbar}>
              <img src={NEW_GB.SOURCE} alt="footer-img" className="mb-0 me-2" />
              <a className="title">GangstaBet</a>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="ms-xl-5 collapse navbar-collapse" id="navbarNav">
              <nav className="nav-container">
                <NavLink
                  to={HOME.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  Home
                </NavLink>
                {/* <a
                  href="https://gangstaverse.co/"
                  target="_blank"
                  className="nav-link mb-2 mb-md-0"
                  activeClassName="active"
                >
                  GangstaVerse <GoLinkExternal />
                </a> */}
                {/* <NavLink
                  to={GBET_ROUTE.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  {" "}
                  $GBET{" "}
                </NavLink> */}
                {/* <NavLink
                  to={ACTIVITY_LOG.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  Activity
                </NavLink> */}
                {/* <NavLink
                  to={ILLUSTRATION_GALLERY.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  Illustration Gallery
                </NavLink> */}
                {/* <NavLink
                  to={LEADERSHIP.INDEX}
                  className="nav-link mb-2 mb-md-0"
                  activeClassName="active"
                >
                  Leaderboard
                </NavLink>{" "} */}
                {/* <NavLink
                  to={MARKET_PLACE.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  Marketplace
                </NavLink> */}
                {/* <NavLink
                  to={FAQ_ROUTE.INDEX}
                  className="nav-link mb-2 mb-md-0"
                  activeClassName="active"
                >
                  FAQ
                </NavLink> */}
                <div
                  className="nav-link mb-2 mb-md-0"
                  onClick={() => {
                    navigate(checkWalletAddress());
                    collapseNavbar();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Wallet
                </div>
                <NavLink
                  to={MIGRATION.INDEX}
                  className={({ isActive }) => `nav-link mb-2 mb-md-0 ${isActive ? 'active' : ''}`}
                  onClick={collapseNavbar}
                >
                  Migration
                </NavLink>
                <div className="wallet-connect-section">
                  <div
                    className="dropdown-toggle"
                    id="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                    className={`${"wallet-icon"}`}
                    width="18"
                    height="18"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12.8338 7.3616V8.56327C12.8338 8.88994 12.5655 9.15827 12.233 9.15827H11.1071C10.4771 9.15827 9.89962 8.69744 9.84712 8.06744C9.81212 7.69993 9.95212 7.35577 10.1971 7.1166C10.413 6.89493 10.7105 6.7666 11.0371 6.7666H12.233C12.5655 6.7666 12.8338 7.03493 12.8338 7.3616Z" />
                    <path d="M8.97199 8.14372C8.91949 7.53122 9.14116 6.93039 9.58449 6.49289C9.95783 6.11372 10.477 5.89206 11.037 5.89206H11.3695C11.5328 5.89206 11.667 5.75789 11.6437 5.59456C11.4862 4.46289 10.5062 3.58789 9.33366 3.58789H3.50033C2.21116 3.58789 1.16699 4.63206 1.16699 5.92122V10.0046C1.16699 11.2937 2.21116 12.3379 3.50033 12.3379H9.33366C10.512 12.3379 11.4862 11.4629 11.6437 10.3312C11.667 10.1679 11.5328 10.0337 11.3695 10.0337H11.107C9.99866 10.0337 9.06533 9.20539 8.97199 8.14372ZM7.58366 6.94206H4.08366C3.84449 6.94206 3.64616 6.74956 3.64616 6.50456C3.64616 6.25956 3.84449 6.06706 4.08366 6.06706H7.58366C7.82283 6.06706 8.02116 6.26539 8.02116 6.50456C8.02116 6.74372 7.82283 6.94206 7.58366 6.94206Z" />
                    <path d="M8.28921 2.32128C8.44088 2.47878 8.30671 2.71211 8.08505 2.71211H3.51755C2.88171 2.71211 2.28671 2.89878 1.79088 3.21961C1.56338 3.36544 1.25421 3.20794 1.36505 2.95711C1.69171 2.19294 2.45588 1.66211 3.33671 1.66211H6.61505C7.29171 1.66211 7.89255 1.90128 8.28921 2.32128Z" />
                  </svg>
                    {(address || suiAddress) ? (
                      <span className="address">
                        {address && suiAddress ? "2 networks connected" : "1 network connected"}
                      </span>
                    ) : (
                      <span className="connect-text">Connect</span>
                    )}
                  </div>
                  <ul className="dropdown-menu">
                     <li>
                     <div
                       className={`nav-link disconnect-connect align-self-baseline ${
                         address ? "hover-red" : "hover-green"
                       } `}
                       onClick={handleConnect}
                     >
                       {address ? "Disconnect" : "Connect"}
                       <div className="icon-network">{address ? `${address.slice(0, 5)}...${address.slice(-5)} | Icon` : '(Icon Network)'}</div>
                     </div>
                   </li>
                      <ConnectModal
                      trigger={
                        <li>
                          <div
                            className={`nav-link disconnect-connect align-self-baseline ${
                              address ? "hover-red" : "hover-green"
                            } `}
                            onClick={() => {suiAddress && disconnectSuiWallet()}}
                          >
                            {suiAddress ? "Disconnect" : "Connect"}
                            <div className="icon-network">{suiAddress ? `${suiAddress.slice(0, 5)}...${suiAddress.slice(-5)} | Sui` : '(Sui Network)'}</div>
                          </div>
                        </li>
                      }
                      open={openSuiModal}
                      onOpenChange={(isOpen) => !suiAddress && setOpenSuiModal(isOpen)}
                    />
                  </ul>
                </div>
              </nav>
              <ConnectWalletModal
                isVisible={connectLoading}
                response={connectSuccess}
                onClick={handleClose}
              />
              <DisconnectModal
                isVisible={disconnect}
                onCancel={() => setDisConnect(false)}
                onDisconnect={handleDisConnected}
              />
              <ConnectionOptionModal
                isVisible={walletConnection}
                onClose={() => setWalletConnection(false)}
                iconexConnection={handleLogin}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 